<script setup>
import ContactTable from '@frontJs/components/tables/projectManagement/customers/ContactTable.vue';
import ProjectManagementLayout from '@frontJs/layouts/ProjectManagementLayout.vue';
import { Head } from '@inertiajs/vue3';
import TabLayout from '@js/components/tabs/TabLayout.vue';
import PageTitle from '@js/components/titles/PageTitle.vue';
import { h } from 'vue';

defineOptions({ layout: ProjectManagementLayout });
</script>

<template>
    <Head>
        <title>Contacts - Clients - Gestion de projet - Datakepler</title>
    </Head>

    <PageTitle> Gestion de projet - Clients - Contacts </PageTitle>

    <TabLayout
        :tabs="{
            actives: {
                title: 'Actifs',
                content: h(ContactTable, { archived: false }),
            },
            eCommerce: {
                title: 'E-commerce',
                content: h(ContactTable, {
                    type: 'e-commerce',
                    archived: false,
                }),
            },
            showcase: {
                title: 'Vitrine',
                content: h(ContactTable, { type: 'showcase', archived: false }),
            },
            marketplace: {
                title: 'Marketplace',
                content: h(ContactTable, {
                    type: 'marketplace',
                    archived: false,
                }),
            },
            shop: {
                title: 'Boutique',
                content: h(ContactTable, { type: 'shop', archived: false }),
            },
            customMade: {
                title: 'Sur-mesure',
                content: h(ContactTable, {
                    type: 'custom-made',
                    archived: false,
                }),
            },
            other: {
                title: 'Autre',
                content: h(ContactTable, { type: 'other', archived: false }),
            },
            archived: {
                title: 'Archivé',
                content: h(ContactTable, { archived: true }),
            },
        }"
    />
</template>
